import React, { Component } from 'react'
import ReactDataTable from "src/views/dashboard/elements/ReactDataTable";
import Service from "src/api/Service";
class ReactTable extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isFetching: true,
      tableRecord: [],
      fieldsToShow: [],
      menusLab: [],
      module: "",
      tabname: "",
      table_title: "",
      error: false,
      errorList: [],
      ReviewChange: [],
      ReviewLogData: [],
      reviewStatusListArray: [],
      reviewStatus: false,
      reviewlog: false,

    }

  }


  async deleteRecord(id) {
    console.log(this.state.tabname);
    var obj = {};
    var url = "configuration_manager/tabKPIDashboard" + "/" + id;
    await Service.delete(url, obj, (status, data) => {
      if (status == 200) {

        window.location.reload(false);


      } else if (status == 400) {
        console.log(data);
      }
    });

  }
  actionDeleteButton(e) {
    console.log(e.id);
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='custom-ui conform-alert'>
            <h3>Are you sure?</h3>
            {/* <p>You want to delete this record?</p> */}
            <button onClick={onClose} >No</button>
            <button
              onClick={() => {
                this.deleteRecord(e.id);
                onClose();
              }}
            >
              Yes
            </button>
          </div>
        );
      }
    });
  }


  async getTableData() {
    try {
      var deftab = this.props.tabname;

      
      await Service.get(
       this.props.module + "/" +
       this.props.tabname+"/"+
       this.props.client_id+"/"+
       this.props.module_id, 
       (status, data) => {
        if (status == 200) {
          var fieldsToShow = [];
          console.log(data);

          this.setState({
            tableRecord: data
          });
        }
      });

      await Service.get( 
      "configuration_manager/tabKPIDashboard/formfields/"+
      this.props.client_id+"/"+
      this.props.module_id,
      (status, data) => {
        if (status == 200) {
          this.setState({
            fieldsToShow: data
          })

        }
      })

      console.log("Updated Dashboard")


      this.setState({
        isFetching: false
      })


    } catch (e) {
      console.log(e)
      this.setState({
        error: true,
        errorList: e,
        isFetching: false
      })

    }
  }
  handleInputChange({ target: { value } }) {
    this.setState({ searchValue: value });
    this.fetchData(value);
  }

  async componentDidMount() {
    if (this.props.tabname !== undefined) {
      await this.getTableData();
    }
  }

  async componentDidUpdate() {

    if (this.state.tabname !== this.props.tabname && this.props.tabname !== undefined) {
      this.setState({
        tabname: this.props.tabname,
        permission: undefined,
        isFetching: true,
        error: false

      })
      await this.getTableData();
    }
  }

  render() {
    if(this.state.isFetching){
        return(<>Please Wait...</>)
    }
   return (
      <>
          <div>
            <ReactDataTable 
            client_id={this.props.client_id}  
            module_id={this.props.module_id} 
            table_title="configuration_manager"  
            tabname='tabKPIDashboard'
            module='configuration_manager'
            tableRecord={this.state.tableRecord} 
            fieldsToShow={this.state.fieldsToShow} />
          </div>
      </>
    )
  }
}

export default ReactTable
